<div class="social_slide">
    <div class="row business_number_details justify-content-center">
        <div class="col-md-4 social_box">
            <div class="social_value">{{ experience }} +</div>
            <div class="social_description">Years of Experience</div>
        </div>
        <div class="col-md-4 social_box">
            <div class="social_value">{{ projects }} +</div>
            <div class="social_description"> Projects Completed</div>
        </div>
        <div class="col-md-4 social_box">
            <div class="social_value">{{ clients }} +</div>
            <div class="social_description">Happy Clients</div>
        </div>
    </div>
</div>